/**
 * DEPRECATED
 * This component was built originally for uncontrolled forms but now we are moving towards
 * controlled forms because they are a more common React pattern. For more info check the link.
 * Alternative:
 * Use components in bench-internal-theme/form-input-fields. If this component doesn't exist, make a
 * copy and refactor so it can be used in a controlled form.
 * @link https://benchco.atlassian.net/browse/IN-2122?utm_medium=referral-external&utm_source=jira-slack&utm_term=
 */

import { colors } from 'bench-style-constants';
import { rgba } from 'color-helpers';
import styled, { css } from 'styled-components';

import withValidation from './withValidation';

const inputValidationErrorBackgroundImageURL = encodeURIComponent(`
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="${colors.copper}"
      d="M12,15a1,1,0,1,1-1,1A1,1,0,0,1,12,15Zm0-8a1,1,0,0,1,1,1v5a1,1,0,0,1-2,0V8A1,1,0,0,1,12,7Zm0,12.875a7.59023,7.59023,0,0,0,5.57227-2.30273A7.59023,7.59023,0,0,0,19.875,12a7.59023,7.59023,0,0,0-2.30273-5.57227A7.59023,7.59023,0,0,0,12,4.125,7.59023,7.59023,0,0,0,6.42773,6.42773,7.59023,7.59023,0,0,0,4.125,12a7.59023,7.59023,0,0,0,2.30273,5.57227A7.59023,7.59023,0,0,0,12,19.875ZM12,3"
    />
  </svg>
`);

const invalidStyling = `
  background-image: url('data:image/svg+xml;utf8,${inputValidationErrorBackgroundImageURL}');
  background-position: 100% 50%;
  background-repeat: no-repeat;
  border-color: ${colors.copper};
  color: ${colors.copper};
  // Prevents the text from overlapping with the background image
  padding-right: 32px;
  
  &:focus {
    background-image: none;
    border-color: ${colors.copper};
    box-shadow: 0 0 4px 1px ${colors.copper};
    color: #3a3b40;
  }
`;

export const StyledTextInput = styled.input`
  background-color: ${colors.white};
  border: 1px solid ${colors.stone};
  border-radius: 2px;
  // "width: 100%" combined with horizontal padding or borders requires "box-sizing: border-box" to
  // prevent horizontal overflow
  box-sizing: border-box;
  color: #3a3b40;
  font-size: 12px;
  min-height: 32px;
  padding: 0 11px;
  width: 100%;

  &:hover {
    border-color: ${colors.dust};
  }

  &:focus {
    border-color: ${colors.dust};
    box-shadow: 0 0 4px 1px ${rgba(colors.creek, 0.65)};
    outline: none;
  }

  ${({ errorText }) =>
    // Show invalid styles if error state has been explicitly set (used by gandalf-validator)
    errorText &&
    css`
      ${invalidStyling};
    `};

  ${({ wasValidated }) =>
    // Only show invlid styles after the input has been validated
    wasValidated &&
    css`
      &:invalid {
        ${invalidStyling};
      }
    `};

  &:disabled {
    background: ${colors.sand};
    border-color: ${colors.sand};
    color: ${colors.dust};
  }

  &::placeholder {
    color: ${colors.dust};
  }
`;

const TextInput = withValidation(StyledTextInput, 'ref');

export default TextInput;
